import {FilterDropdown} from 'src/components/FilterDropdown';

/**
 * Tri-state reconciliation filter for a raw-transaction list:
 * - all: no server-side narrowing (reconciled arg omitted)
 * - reconciled: only rows claimed by a reconciliation (reconciledAt exists)
 * - unreconciled: rows no reconciliation has claimed yet
 */
export type ReconciledFilter = 'all' | 'reconciled' | 'unreconciled';

/** Decode a reconciled filter from a URL query value; anything else is 'all'. */
export const parseReconciledFilter = (
  value: string | null,
): ReconciledFilter =>
  value === 'reconciled' || value === 'unreconciled' ? value : 'all';

/** The `reconciled` query argument for a filter state; undefined means "all". */
export const reconciledArg = (filter: ReconciledFilter): boolean | undefined =>
  filter === 'reconciled' ? true : filter === 'unreconciled' ? false : undefined;

type Props = {
  value: ReconciledFilter;
  onChange: (value: ReconciledFilter) => void;
};

/**
 * Filter pill (styled like AllocationFilterSelect via FilterDropdown) that
 * drives the query's tri-state `reconciled` argument — the same argument the
 * per-account Reconcile tab pins to `false`, surfaced here so cross-account
 * activity can be narrowed to what reconciliation has (or hasn't) claimed.
 */
export const ReconciledFilterSelect = ({value, onChange}: Props) => (
  <FilterDropdown
    label="Reconciled"
    allLabel="All"
    options={[
      {key: 'reconciled', label: 'Reconciled'},
      {key: 'unreconciled', label: 'Not reconciled'},
    ]}
    value={value}
    onChange={(key) => onChange(parseReconciledFilter(key))}
  />
);
